import React from 'react';
import PropTypes from 'prop-types';
import { CapsuleButton } from '../../../../../../../CommonComponents/Commons/commonComponents';
import {
    CheckboxContent,
    ComponentDivider,
    CheckboxWrapper,
    FormWrapper,
    AccessKeyWrapper,
    VanguardDonor,
    RouteTo,
    CapsuleButtonWrapper,
    ContentKeyWrapper
} from '../styles';
import {
  LinkTo,
  CustomCheckbox,
} from '../../../../../../../../src/CommonComponents/commonStyles';
import { Form } from 'antd';
import MutualFundAccount from './MutualFundAccount';
import { ContentContainerSpaceSmall } from '../../../styles';
import {
  addMutualFund,
  checkVGMutualFund,
  generateAccesKey,
} from '../../../actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser,
} from '../../../../../../../utils/sessionUtil';
import loaderIcon from '../../../../../../../assets/icons/loader.gif';
import { Loader } from '../../../../../../Investments/Pages/RecommendAnExchangeNew/components/summary/styles';
import {
  defaultMutualFundAHAV,
  defaultSecurityGiftAHAV,
} from '../../CommonComponents/Data';
import { BUSINESS_FUNCTION } from '../../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { checkCSRBusinessFunction } from '../../../../../../../CSR/utils/CommonUtils';
import { NotWebRegister } from '../../../../../../../CSR/CommonComponents/style';
import { recordError } from '../../../../../../../utils/commonUtil';
import { assetHeldAtVanguardState } from '../../../selectors';
import GlobalModal from "../../../../../../../../src/CommonComponents/AlertModal/GlobalModal";

export class AssetHeldAtVanguard extends React.Component {
  constructor(props) {
    super(props);
    this.addAnotherMF = this.addAnotherMF.bind(this);
    this.addAnotherSG = this.addAnotherSG.bind(this);
    this.removeMfAccount = this.removeMfAccount.bind(this);
    this.removeSgAccount = this.removeSgAccount.bind(this);
    this.state = { show: true };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isVGselected !== this.props.isVGselected ||
      nextProps.isSGselected !== this.props.isSGselected
    ) {
      this.forceUpdate();
    }
  }

  componentDidMount()
    {
        let checkBoxNodes  = document.querySelectorAll(".ant-checkbox-input");
        if(checkBoxNodes.length)
        {
            [...checkBoxNodes].forEach((chk)=>{
                    chk.setAttribute("aria-label","checkbox input")
            })
        }
    }

  addAnotherMF = (e) => {
    try {
      let storeData = this.props.mfAccountDetails;
      if (storeData.length < 20) {
        let emptyOb = JSON.parse(JSON.stringify(defaultMutualFundAHAV[0]));
        let loggedInAddress = this.props.loggedInAddress;
        emptyOb.Donors[0] = loggedInAddress;
        Array.prototype.push2 = function(x) {
          this.push(x);
          return this;
        };
        let updatedData = storeData.push2(emptyOb);
        this.props.addMutualAccount(updatedData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  addAnotherSG = (e) => {
    try {
      let storeData = this.props.sgAccountDetails;
      if (storeData.length < 20) {
        let emptyOb = JSON.parse(JSON.stringify(defaultSecurityGiftAHAV[0]));
        let loggedInAddress = this.props.loggedInAddress;
        emptyOb.Donors[0] = loggedInAddress;
        Array.prototype.push2 = function(x) {
          this.push(x);
          return this;
        };
        let updatedData = storeData.push2(emptyOb);
        this.props.addSecurityGift(updatedData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  removeMfAccount = (index) => {
    try {
      let storeData = this.props.mfAccountDetails;
      storeData.splice(index, 1);
      this.props.addMutualAccount(storeData);
    } catch (error) {
      recordError(error);
    }
  };

  removeSgAccount = (index) => {
    try {
      let storeData = this.props.sgAccountDetails;
      this.props.addSecurityGift(storeData);
    } catch (error) {
      recordError(error);
    }
  };

  generateAccessKey = () => {
    try {
      const data = {
        metaData: {
          method: 'GET',
          url: `/donor-portal/api/profile/${
            getPrimaryAccount().userId
          }/generateAccessKeyWithAccountIdAndPartyId?partyId=${
            getAccountData().partyId
          }`,
        },
        isKeyGenerated: false,
      };
      this.props.generateAccesKey(data);
      this.setState({ show: false });
    } catch (error) {
      recordError(error);
    }
  };

  copyToClipBoard(accessKey) {
    try {
      if (accessKey) {
        let textArea = document.createElement('textarea');
        textArea.value = accessKey;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        GlobalModal({ contents: 'Copied text: ' + accessKey + ' to clipboard' });
      }
    } catch (error) {
      recordError(error);
    }
  }

  accessKeyChange = (e) => {
    if (!e.target.checked) {
      const elmnt = document.getElementById('assetHeldAccessId');
      elmnt.nextElementSibling.style.borderColor = '#b6bdbd';
    }
    this.props.checkAccessKey(e);
  };

  markup = (value) => {
    return { __html: value };
  };

  render() {
    let show = this.state.show;
    let date = new Date();
    let currTime = date.getTime();
    const { csrBusinessFunction, navBarData, id } = this.props;
    return (
      <ContentContainerSpaceSmall>
        <div className='fluid'>
          <CheckboxWrapper marginBottom='30px' mb='20px'>
            <CustomCheckbox
              id='assetHeldAccessId'
              data-test='access-id'
              onChange={(e) => this.accessKeyChange(e)}
              checked={this.props.accessSelected}
            >
              {' '}
            </CustomCheckbox>
            <CheckboxContent marginLeft='0px' mLB='-6px'>
              I am eligible for electronic authorization
            </CheckboxContent>
          </CheckboxWrapper>
          {this.props.accessSelected ? (
            this.props.isAccessKeySuccess ? (
              this.props.accessKeyGenerated ||
              this.props.accessKeyLinked ||
              (this.props.accessKey && this.props.accessKey.accessKey) ? (
                this.props.accessKeyLinked ? (
                  <>
                    <VanguardDonor>
                      <div
                        dangerouslySetInnerHTML={this.markup(
                          this.props.pageDetails.accessKeyLinked
                        )}
                      ></div>
                    </VanguardDonor>
                    <AccessKeyWrapper>
                      <LinkTo
                        href='https://investor.vanguard.com/'
                        target='blank'
                      >
                        Take me to vanguard.com
                      </LinkTo>
                    </AccessKeyWrapper>
                  </>
                ) : (
                  <>
                    {this.props.isAccessKeySuccess ? (
                      !(
                        this.props.accessKey.validTill &&
                        this.props.accessKey.validTill > currTime
                      ) ? (
                        <>
                          <VanguardDonor>
                            <div
                              dangerouslySetInnerHTML={this.markup(
                                this.props.pageDetails.accessKeyNotGenerated
                              )}
                            ></div>
                          </VanguardDonor>
                          <AccessKeyWrapper>
                            {isGeminiUser() &&
                            navBarData &&
                            !navBarData.webAccess ? (
                              <NotWebRegister>
                                {' '}
                                User is not web registered{' '}
                              </NotWebRegister>
                            ) : (
                              <RouteTo
                                data-test='route-to'
                                onClick={() => this.generateAccessKey()}
                                className={
                                  isGeminiUser() &&
                                  checkCSRBusinessFunction(
                                    BUSINESS_FUNCTION[
                                      'DONOR_PORTAL_ACCESS_KEY_FULL_ACCESS'
                                    ],
                                    csrBusinessFunction
                                  )
                                    ? 'disable-hyperlink'
                                    : ''
                                }
                              >
                                Generate Access Key
                              </RouteTo>
                            )}
                          </AccessKeyWrapper>
                        </>
                      ) : (
                        <>
                          <VanguardDonor>
                            <div
                              dangerouslySetInnerHTML={this.markup(
                                this.props.pageDetails.accessKeyGenerated
                              )}
                            ></div>
                          </VanguardDonor>
                          <AccessKeyWrapper>
                            The Access Key will expire four hours from the time
                            that it is generated.
                          </AccessKeyWrapper>
                          <AccessKeyWrapper
                            data-test='clip-board'
                            onClick={this.copyToClipBoard.bind(
                              this,
                              this.props.accessKey.accessKey
                            )}
                          >
                            <LinkTo>{this.props.accessKey.accessKey}</LinkTo>
                          </AccessKeyWrapper>
                          <ContentKeyWrapper>Your Access Key is the alphanumeric code linked above. It will expire in four hours.</ContentKeyWrapper>
                          <ContentKeyWrapper>If four hours have passed, or if you have entered an Access Key incorrectly after four attempts, you may return here to generate a new Access Key.</ContentKeyWrapper>
                        </>
                      )
                    ) : (
                      <AccessKeyWrapper>
                        <Loader src={loaderIcon} alt='loader' />
                      </AccessKeyWrapper>
                    )}
                    <AccessKeyWrapper>
                      <LinkTo
                        href='https://investor.vanguard.com/'
                        target='_blank'
                      >
                        Take me to vanguard.com
                      </LinkTo>
                    </AccessKeyWrapper>
                  </>
                )
              ) : (
                <>
                  <VanguardDonor>
                    <div
                      dangerouslySetInnerHTML={this.markup(
                        this.props.pageDetails.accessKeyNotGenerated
                      )}
                    ></div>
                  </VanguardDonor>
                  <AccessKeyWrapper>
                    {isGeminiUser() && navBarData && !navBarData.webAccess ? (
                      <NotWebRegister>
                        {' '}
                        User is not web registered{' '}
                      </NotWebRegister>
                    ) : (
                      <RouteTo
                        data-test='route-to'
                        onClick={() => this.generateAccessKey()}
                        className={
                          isGeminiUser() &&
                          checkCSRBusinessFunction(
                            BUSINESS_FUNCTION[
                              'DONOR_PORTAL_ACCESS_KEY_FULL_ACCESS'
                            ],
                            csrBusinessFunction
                          )
                            ? 'disable-hyperlink'
                            : ''
                        }
                      >
                        Generate Access Key
                      </RouteTo>
                    )}
                  </AccessKeyWrapper>
                </>
              )
            ) : (
              <AccessKeyWrapper>
                <Loader src={loaderIcon} alt='loader' />
              </AccessKeyWrapper>
            )
          ) : (
            ''
          )}
          <ComponentDivider />
          <CheckboxWrapper marginBottom='30px' mb='20px'>
            <CustomCheckbox
              data-test='check-box1'
              onChange={this.props.checkVGFund}
              checked={this.props.isVGselected}
            >
              {' '}
            </CustomCheckbox>
            <CheckboxContent marginLeft='0px' mLB='-6px'>
              I am not eligible for electronic authorization - Enter a Vanguard
              mutual fund{' '}
            </CheckboxContent>
          </CheckboxWrapper>
          {this.props.isVGselected === true ? (
            <>
              <FormWrapper>
                {Array.prototype.map.call(
                  this.props.mfAccountDetails,
                  (account, index) => (
                    <>
                      <MutualFundAccount
                        accountId={index}
                        count={this.props.mfAccountDetails.length}
                        type={account.type}
                        contributionType='mutualFund'
                      />
                      {index !== 0 ? (
                        <CapsuleButtonWrapper
                          marginBottom='30px'
                          marginRight='20px'
                        >
                          <CapsuleButton
                            data-test='remove-acc'
                            text='Remove Account'
                            onClick={(e) => this.removeMfAccount(index)}
                            id={'button' + index}
                          />
                        </CapsuleButtonWrapper>
                      ) : null}
                      {index < this.props.mfAccountDetails.length - 1 ? (
                        <ComponentDivider
                          marginTop='10px'
                          marginBottom='40px'
                          mT='0px'
                          mB='40px'
                        />
                      ) : null}
                    </>
                  )
                )}
                <CapsuleButtonWrapper marginBottom='30px'>
                  <CapsuleButton
                    data-test='add-another-acc'
                    text='Add another account'
                    iconType='add'
                    padding='5px 20px'
                    disabled={
                      this.props.mfAccountDetails.length === 20 ? true : false
                    }
                    onClick={(e) => this.addAnotherMF(e)}
                    id={id && 'btnAddAnotherAccount' + id}
                  />
                </CapsuleButtonWrapper>
              </FormWrapper>
            </>
          ) : (
            ''
          )}
          <ComponentDivider />
          <CheckboxWrapper marginBottom='30px' mb='20px'>
            <CustomCheckbox
              data-test='check-box1'
              onChange={this.props.checkSGFund}
              checked={this.props.isSGselected}
            >
              {' '}
            </CustomCheckbox>
            <CheckboxContent marginLeft='0px' mLB='-6px'>
              I am not eligible for electronic authorization - Enter a Security
              (Other than a Vanguard mutual fund){' '}
            </CheckboxContent>
          </CheckboxWrapper>
          {this.props.isSGselected === true ? (
            <>
              <FormWrapper>
                {Array.prototype.map.call(
                  this.props.sgAccountDetails,
                  (account, index) => (
                    <>
                      <MutualFundAccount
                        accountId={index}
                        count={this.props.sgAccountDetails.length}
                        type={account.type}
                        contributionType='securityGift'
                      />
                      {index !== 0 ? (
                        <CapsuleButtonWrapper
                          marginBottom='30px'
                          marginRight='20px'
                        >
                          <CapsuleButton
                            data-test='remove-acc1'
                            text='Remove Account'
                            id={'button' + index}
                            onClick={(e) => this.removeSgAccount(index)}
                          />
                        </CapsuleButtonWrapper>
                      ) : null}
                      {index < this.props.sgAccountDetails.length - 1 ? (
                        <ComponentDivider
                          marginTop='10px'
                          marginBottom='40px'
                          mT='0px'
                          mB='40px'
                        />
                      ) : null}
                    </>
                  )
                )}
                <CapsuleButtonWrapper marginBottom='30px'>
                  <CapsuleButton
                    data-test='add-btn-add'
                    text='Add another account'
                    iconType='add'
                    padding='5px 20px'
                    disabled={
                      this.props.sgAccountDetails.length === 20 ? true : false
                    }
                    onClick={(e) => this.addAnotherSG(e)}
                    id={id && 'btnAddAnotherAccount' + id}
                  />
                </CapsuleButtonWrapper>
              </FormWrapper>
            </>
          ) : (
            ''
          )}
        </div>
      </ContentContainerSpaceSmall>
    );
  }
}

const WrappedForm = Form.create({ name: 'assetHeldAtVanguard' })(
  AssetHeldAtVanguard
);

WrappedForm.propTypes = {
  mfAccountDetails: PropTypes.object,
  sgAccountDetails: PropTypes.object,
  isVGselected: PropTypes.bool,
  isSGselected: PropTypes.bool,
  accessSelected: PropTypes.bool,
  accessKey: PropTypes.string,
  loggedInAddress: PropTypes.object,
  csrBusinessFunction: PropTypes.array,
  navBarData: PropTypes.object,
  accessKeyGenerated: PropTypes.bool,
  accessKeyLinked: PropTypes.bool,
  isAccessKeySuccess: PropTypes.func,
  pageDetails: PropTypes.object,
  addMutualAccount: PropTypes.func,
  addSecurityGift: PropTypes.func,
  checkVGFund: PropTypes.func,
  checkSGFund: PropTypes.func,
  checkAccessKey: PropTypes.func,
  generateAccesKey: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...assetHeldAtVanguardState(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  addMutualAccount: (arr) =>
    dispatch(
      addMutualFund({
        value: arr,
        contributionType: 'mutualFund',
        assetHeld: 'assetHeldatVG',
        selected: 'mfSelected',
      })
    ),
  addSecurityGift: (arr) =>
    dispatch(
      addMutualFund({
        value: arr,
        contributionType: 'securityGift',
        assetHeld: 'assetHeldatVG',
        selected: 'sgSelected',
      })
    ),
  checkVGFund: (e) =>
    dispatch(
      checkVGMutualFund({
        value: e.target.checked,
        property: 'mfSelected',
        assetHeld: 'assetHeldatVG',
      })
    ),
  checkSGFund: (e) =>
    dispatch(
      checkVGMutualFund({
        value: e.target.checked,
        property: 'sgSelected',
        assetHeld: 'assetHeldatVG',
      })
    ),
  checkAccessKey: (e) =>
    dispatch(
      checkVGMutualFund({
        value: e.target.checked,
        property: 'accessSelected',
        assetHeld: 'assetHeldatVG',
      })
    ),
  generateAccesKey: (data) => dispatch(generateAccesKey(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WrappedForm)
);
